<template>
  <div>
    <v-card>
      <v-toolbar dense color="primary" dark align="center">
        <v-row>
          <v-col cols="5" align="left">
            <v-toolbar-title>Gestione Part Program Macchina</v-toolbar-title>
          </v-col>
          <v-col cols="1">
            <v-btn small light @click="setMachinePrograms">
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn small light @click="addPartProgram">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn small light @click="importProgram">
              <v-icon color="primary">mdi-folder</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="3" align="right">
            <v-btn small light @click="part_program_list = new Array()">
              <v-icon color="indigo">mdi-broom</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" align="right">
            <v-btn small light @click="refresh">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <!-- Lista part program -->
      <v-container
        v-if="interfaces != null && schema != null && part_program_list != null"
      >
        <v-expansion-panels v-model="expanded">
          <v-expansion-panel v-for="(program, i) in part_program_list" :key="i">
            <!-- Header testata part program -->
            <v-expansion-panel-header>
              <v-row no-gutters align="center">
                <v-col cols="3">
                  {{ program.name }}
                </v-col>
                <v-col cols="1">
                  <v-btn small light class="mr-5" @click="duplicate(program)">
                    <v-icon color="primary">mdi-content-copy</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="1">
                  <v-btn
                    small
                    light
                    class="mr-5"
                    @click="exportProgram(program)"
                    @click.native.stop
                  >
                    <v-icon color="primary">mdi-export-variant</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="6"> </v-col>
                <v-col cols="1">
                  <v-btn small light @click="deletePartProgram(program)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-header>

            <!-- Body testata part program -->
            <v-expansion-panel-content>
              <v-row align="center">
                <v-col cols="6" align="center">
                  <v-text-field v-model="program.name" label="Nome programma" />
                </v-col>
                <v-col cols="4" align="center">
                  <v-text-field
                    type="number"
                    v-model="program.timeout"
                    label="Timeout esecuzione"
                  />
                </v-col>
              </v-row>
              <v-divider />

              <!-- Passaggi -->
              <v-row align="center" class="my-3">
                <v-col cols="11" align="left">
                  <h2>Passaggi</h2>
                </v-col>
                <v-col cols="1" align="center">
                  <v-btn small light @click="addStep(program)">
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-expansion-panels>
                <v-expansion-panel v-for="(step, j) in program.steps" :key="j">
                  <!-- Header passaggi part program -->
                  <v-expansion-panel-header>
                    <v-row no-gutters>
                      <v-col cols="4"
                        >Sq: {{ step.sequence_type }} -- {{ step.name }}</v-col
                      >
                      <v-col cols="1">
                        <v-btn
                          small
                          light
                          @click="moveUp(step, program)"
                          @click.native.stop
                        >
                          <v-icon color="primary">mdi-arrow-up</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="1">
                        <v-btn
                          small
                          light
                          @click="moveDown(step, program)"
                          @click.native.stop
                        >
                          <v-icon color="primary">mdi-arrow-down</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="1">
                        <v-btn
                          small
                          light
                          class="mr-5"
                          @click="duplicateStep(step, program)"
                          @click.native.stop
                        >
                          <v-icon color="primary">mdi-content-copy</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="4" />
                      <v-col cols="1">
                        <v-btn small light @click="deleteStep(step, program)">
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <!-- Body passaggi part program -->
                  <v-expansion-panel-content>
                    <!-- Dati generali passaggio -->
                    <v-row align="center">
                      <v-col cols="3" align="center">
                        <v-select
                          v-model="step.name"
                          label="Nome passaggio"
                          v-if="step.access_type == 3"
                          :items="
                            step.access_level == 0 ? articoloCols : commessaCols
                          "
                          item-text="Field"
                        />
                        <v-text-field
                          v-model="step.name"
                          label="Nome passaggio"
                          v-else
                        />
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-select
                          v-model="step.sequence_type"
                          label="Tipo Sequenza"
                          :items="sequence_types.values"
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        align="center"
                        v-if="step.sequence_type != 1"
                      >
                        <v-select
                          v-model="step.interface_id"
                          label="Interfaccia"
                          :items="getOutputInterfaces(interfaces)"
                          item-text="interface_name"
                          item-value="interface_id"
                          @change="resetRegisterFields($event, step)"
                        />
                      </v-col>
                    </v-row>

                    <!-- Dati specifici passaggio -->
                    <v-row align="center" v-if="step.sequence_type == 1">
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.default_value"
                          label="Attesa (ms)"
                        />
                      </v-col>
                    </v-row>
                    <!-- Riga accesso dato -->
                    <v-row align="center" v-if="step.sequence_type == 0">
                      <v-col cols="3">
                        <v-select
                          v-model="step.access_type"
                          label="Modalità accesso dato"
                          :items="access_types"
                          @change="step.default_value = null"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-select
                          v-model="step.access_level"
                          label="Livello accesso dato"
                          :items="access_levels"
                        />
                      </v-col>
                      <v-col cols="3" align="center">
                        <v-select
                          v-model="step.type"
                          label="Tipo dato"
                          :items="schema.data_types"
                          @change="step.default_value = null"
                          item-value="id_dato_quickconnext"
                          item-text="nome"
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        align="center"
                        v-if="step.type != null && step.access_type < 2"
                      >
                        <DynamicInput
                          v-model="step.default_value"
                          :type="getDataTypeById(step.type).tipo"
                          label="Valore Default"
                        />
                      </v-col>
                    </v-row>
                    <!-- Riga limiti dato -->
                    <v-row
                      v-if="
                        isNumber(step) &&
                        step.access_type > 0 &&
                        step.sequence_type == 0
                      "
                    >
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.hard_min_value"
                          label="Limite minimo valore"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.hard_max_value"
                          label="Limite massimo valore"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.min_value"
                          label="Valore minimo default"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          v-model="step.boundaries.max_value"
                          label="Valore massimo default"
                        />
                      </v-col>
                    </v-row>
                    <v-divider />

                    <!-- Registri -->
                    <v-row class="my-3" v-if="step.sequence_type != 1">
                      <v-col cols="12" align="left">
                        <h2>Impostazioni registro</h2>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      justify="start"
                      v-if="step.sequence_type != 1"
                    >
                      <template
                        v-for="(register, k, k1, k2) in getRegister(step)"
                      >
                        <v-col cols="3" :key="k" align="center">
                          <DynamicInput
                            v-model="step.register[register.field].value"
                            :items="register.values"
                            :type="register.type"
                            :label="register.name"
                          />
                        </v-col>
                        <v-col
                          cols="1"
                          :key="k1"
                          align="center"
                          v-if="
                            (register.type == 'string' ||
                              register.type == 'textarea') &&
                            step.sequence_type == 0
                          "
                        >
                          <v-btn
                            small
                            light
                            @click="
                              $refs.param_dialog.open(
                                step.register[register.field]
                              )
                            "
                          >
                            <v-icon color="primary"
                              >mdi-format-list-text</v-icon
                            >
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="1"
                          v-if="
                            !(
                              register.type == 'string' ||
                              register.type == 'textarea'
                            ) && step.sequence_type == 0
                          "
                          :key="k2"
                        >
                          <v-icon disabled>mdi-format-list-text</v-icon>
                        </v-col>
                      </template>
                    </v-row>

                    <!-- Feedback -->
                    <v-row class="my-3" v-if="step.sequence_type == 2">
                      <v-col cols="12" align="left">
                        <h2>Valore Feedback</h2>
                      </v-col>
                    </v-row>
                    <v-row align="center" v-if="step.sequence_type == 2">
                      <v-col cols="2">
                        <v-text-field
                          type="number"
                          v-model="step.feedback.timeout"
                          label="Timeout esecuzione"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          type="number"
                          v-model="step.feedback.polling_frequency"
                          label="Frequenza di controllo (ms)"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox
                          v-model="step.feedback.const"
                          label="Usa valore fisso"
                        />
                      </v-col>
                      <v-col cols="3" v-if="step.feedback.const != true">
                        <v-select
                          label="Valore step"
                          :items="getFeedbackSteps(step, program.steps)"
                          item-text="name"
                          item-value="id"
                          v-model="step.feedback.src"
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        align="center"
                        v-if="step.feedback.const == true"
                      >
                        <v-select
                          v-model="step.feedback.cast"
                          label="Tipo dato"
                          :items="schema.data_types"
                          @change="step.feedback.src = null"
                          item-value="id_dato_quickconnext"
                          item-text="nome"
                        />
                      </v-col>
                      <v-col cols="3" v-if="step.feedback.const == true">
                        <DynamicInput
                          v-if="step.feedback.cast != null"
                          label="Valore"
                          :type="getDataTypeById(step.feedback.cast).tipo"
                          :items="schema.data_types[step.feedback.cast].values"
                          v-model="step.feedback.src"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-card>
    <DialogParametriRegistro
      ref="param_dialog"
      :schema="schema"
      :access_types="access_types"
    />
    <v-snackbar v-model="ui.snackbar" color="success"
      >Salvataggio eseguito con successo</v-snackbar
    >
  </div>
</template>
<script>
import DynamicInput from "../.common/DynamicInput.vue";
import DialogParametriRegistro from "./DialogParametriRegistro.vue";
export default {
  name: "GestionePartProgram",
  props: {
    id_macchina: [Number, String],
  },
  components: {
    DynamicInput,
    DialogParametriRegistro,
  },
  data() {
    return {
      articoloCols: [],
      commessaCols: [],
      access_levels: [
        { text: "Articolo", value: 0 },
        { text: "Commessa", value: 1 },
        { text: "Work Order", value: 2 },
      ],
      access_types: [
        { text: "Costante", value: 0 },
        { text: "Opzionale", value: 1 },
        { text: "Obbligatorio", value: 2 },
        { text: "Automatico", value: 3 },
      ],
      clickedDup: false,
      expanded: [],
      interfaces: null,
      NETWORK: null,
      part_program_list: null,
      schema: null,
      sequence_types: new Object(),
      ui: {
        snackbar: false,
      },
    };
  },
  mounted() {
    this.getCols();
    this.NETWORK = this.$store.state.Network;
    this.refresh();
  },
  watch: {
    expanded() {
      if (this.clickedDup) {
        this.expanded = [];
        this.clickedDup = false;
      }
    },
  },
  methods: {
    //#region Configurator

    //#region Common
    getCols() {
      let requestArticolo = {
        controller: "global",
        method: "POST",
        richiesta: {
          action: "getcolonne",
          token: localStorage.getItem("user_token"),
          tabella: "articolo",
        },
      };

      this.$store.dispatch("api", requestArticolo).then((res) => {
        this.articoloCols = Array.from(res.data.result);
        this.articoloCols.sort((a, b) => a.Field.localeCompare(b.Field));
        this.articoloCols.forEach((e) => {
          e.Field = "#" + e.Field;
        });
      });

      let requestCommessa = {
        controller: "global",
        method: "POST",
        richiesta: {
          action: "getcolonne",
          token: localStorage.getItem("user_token"),
          tabella: "commessa",
        },
      };

      this.$store.dispatch("api", requestCommessa).then((res) => {
        this.commessaCols = Array.from(res.data.result);
        this.commessaCols.sort((a, b) => a.Field.localeCompare(b.Field));
        this.commessaCols.forEach((e) => {
          e.Field = "#" + e.Field;
        });
      });
    },
    duplicate(item) {
      this.clickedDup = true;
      let id = 1;
      const programs = this.part_program_list;
      for (let i = 0; i < programs.length; i++) {
        id = Math.max(Number(programs[i].id), id) + 1;
      }
      this.part_program_list.push(JSON.parse(JSON.stringify(item)));
      this.part_program_list[this.part_program_list.length - 1].id = id;
    },
    moveDown(step, prog) {
      if (step.id < prog.steps.length) {
        var temp = JSON.parse(JSON.stringify(prog.steps[step.id]));
        temp.id = step.id;
        prog.steps[step.id] = JSON.parse(JSON.stringify(step));
        prog.steps[step.id].id += 1;
        prog.steps[step.id - 1] = temp;
        this.$forceUpdate();
      }
    },
    moveUp(step, prog) {
      if (step.id > 1) {
        var temp = JSON.parse(JSON.stringify(prog.steps[step.id - 2]));
        temp.id = step.id;
        prog.steps[step.id - 2] = JSON.parse(JSON.stringify(step));
        prog.steps[step.id - 2].id -= 1;
        prog.steps[step.id - 1] = temp;
        this.$forceUpdate();
      }
    },
    importProgram() {
      console.log("import");
      var input = document.createElement("input");
      input.type = "file";

      input.onchange = (e) => {
        var file = e.target.files[0];
        console.log(file);
        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");

        reader.onload = (readerEvent) => {
          const fileText = readerEvent.target.result;
          this.addPartProgram();
          this.part_program_list[this.part_program_list.length - 1] = JSON.parse(fileText);
          this.$forceUpdate();
        };
      };

      input.click();
    },
    exportProgram(prog) {
      console.log(prog);
      const temp = document.createElement("a");
      const file = new Blob([JSON.stringify(prog)], { type: "text/plain" });
      temp.href = URL.createObjectURL(file);
      temp.setAttribute("download", prog.name);
      document.body.appendChild(temp);
      temp.click();
      document.body.removeChild(temp);
      console.log("test");
    },
    duplicateStep(step, prog) {
      prog.steps.push(JSON.parse(JSON.stringify(step)));
      prog.steps[prog.steps.length - 1].id = prog.steps.length;
    },
    getDataTypeById(id) {
      const data_types = this.schema.data_types;
      for (let i = 0; i < data_types.length; i++) {
        const data_type = data_types[i];
        if (data_type.id_dato_quickconnext == id) {
          return data_type;
        }
      }
      return new Object();
    },
    getInterfaceById(id) {
      const interfaces = this.interfaces;
      for (let i = 0; i < interfaces.length; i++) {
        const interf = interfaces[i];
        if (interf.interface_id == id) {
          return interf;
        }
      }
      return null;
    },
    getModuleById(id) {
      const modules = this.schema.modules;
      for (let i = 0; i < modules.length; i++) {
        const module = modules[i];
        if (module.id_modulo == id) {
          return module;
        }
      }
      return null;
    },
    getOutputInterfaces(interfaces) {
      const result = new Array();
      for (let i = 0; i < interfaces.length; i++) {
        const interf = interfaces[i];
        const module = this.getModuleById(interf.module_id);
        if (module != null) {
          if (module.output == 1) {
            result.push(interf);
          }
        }
      }
      return result;
    },
    getSequenceTypes() {
      const program_fields = this.schema.default_fields.part_program_fields;
      for (let i = 0; i < program_fields.length; i++) {
        const field = program_fields[i];
        if (field.field == "sequence_type") {
          return field;
        }
      }
      return new Object();
    },
    isNumber(item) {
      return this.getDataTypeById(item.type).tipo == "number";
    },
    //#endregion

    //#region Part Program
    addPartProgram() {
      let id = 1;
      const programs = this.part_program_list;
      for (let i = 0; i < programs.length; i++) {
        id = Math.max(Number(programs[i].id), id) + 1;
      }
      programs.push({
        name: "Part program #" + id,
        id: id,
        steps: [],
        timeout: 15,
      });
    },
    deletePartProgram(program) {
      this.part_program_list.splice(this.part_program_list.indexOf(program), 1);
    },
    //#endregion

    //#region Step
    addStep(program) {
      let id = 1;
      for (let i = 0; i < program.steps.length; i++) {
        id = Math.max(Number(program.steps[i].id), id) + 1;
      }
      program.steps.push({
        name: "Passaggio #" + id,
        register: new Object(),
        access_type: 1,
        access_level: 0,
        type: null,
        interface_id: null,
        id: id,
        default_value: null,
        sequence_type: Number(this.sequence_types.default_value),
        feedback: {
          const: false,
          src: null,
          cast: null,
          timeout: 5,
          polling_frequency: 200,
        },
        boundaries: {
          min_value: null,
          max_value: null,
          hard_min_value: null,
          hard_max_value: null,
        },
      });
    },
    deleteStep(step, program) {
      program.steps.splice(program.steps.indexOf(step), 1);
    },
    //#endregion

    //#region Feedback
    getFeedbackSteps(step, steps) {
      const result = new Array();
      for (let i = 0; i < steps.length; i++) {
        const step_i = steps[i];
        if (step_i == step) {
          break;
        }
        if (step_i.sequence_type == 0) {
          result.push(step_i);
        }
      }
      return result;
    },
    //#endregion

    //#region Registri
    getRegister(step) {
      try {
        for (let i = 0; i < this.interfaces.length; i++) {
          const interf = this.interfaces[i];
          if (interf.interface_id == step.interface_id) {
            const module = this.getModuleById(interf.module_id);
            if (module != null) {
              return module.part_program_fields;
            }
            break;
          }
        }
        return [];
      } catch {
        return [];
      }
    },
    resetRegisterFields(id, step) {
      for (let i = 0; i < this.interfaces.length; i++) {
        const interf = this.interfaces[i];
        if (interf.interface_id == id) {
          step.register = new Object();
          const module = this.getModuleById(interf.module_id);
          if (module != null) {
            const part_program_fields = module.part_program_fields;
            for (let j = 0; j < part_program_fields.length; j++) {
              const field = part_program_fields[j];
              step.register[field.field] = {
                value: field.default_value,
                parameters: new Array(),
              };
            }
          }
          break;
        }
      }
    },
    //#endregion

    //#region Get
    getMachineConfiguration() {
      this.interfaces = null;
      const that = this;
      return new Promise((resolve, reject) => {
        that.NETWORK.AjaxRequest({
          controller: "quickconnext",
          endpoint: "connext",
          response: { parse: false },
          body: {
            action: "getmachineconfiguration",
            token: localStorage.user_token,
            machine_id: that.id_macchina,
          },
          method: "POST",
          on: {
            load: function (response) {
              response = JSON.parse(response)[0];
              try {
                that.interfaces = JSON.parse(
                  decodeURIComponent(escape(atob(response.conf_4_0)))
                );
              } catch {
                that.interfaces = null;
              }
              resolve();
            },
            error: function () {
              reject();
            },
          },
        });
      });
    },
    getMachinePrograms() {
      this.part_program_list = null;
      const that = this;
      return new Promise((resolve, reject) => {
        that.NETWORK.AjaxRequest({
          controller: "quickconnext",
          endpoint: "connext",
          response: { parse: false },
          body: {
            action: "getmachineprograms",
            machine_id: that.id_macchina,
            token: localStorage.user_token,
          },
          method: "POST",
          on: {
            load: function (response) {
              try {
                resolve(JSON.parse(decodeURIComponent(escape(atob(response)))));
              } catch {
                resolve(new Array());
              }
            },
            error: function () {
              reject();
            },
          },
        });
      });
    },
    getPartProgramSchema() {
      this.schema = null;
      const that = this;
      return new Promise((resolve, reject) => {
        that.NETWORK.AjaxRequest({
          controller: "quickconnext",
          endpoint: "connext",
          response: { parse: false },
          body: {
            action: "getpartprogramschema",
            token: localStorage.user_token,
          },
          method: "POST",
          on: {
            load: function (response) {
              that.schema = JSON.parse(response);
              that.sequence_types = that.getSequenceTypes();
              resolve();
            },
            error: function () {
              reject();
            },
          },
        });
      });
    },
    refresh() {
      const that = this;
      let part_program_list = null;
      this.getMachinePrograms()
        .then((data) => {
          part_program_list = data;
          return that.getMachineConfiguration();
        })
        .then(() => {
          return that.getPartProgramSchema();
        })
        .then(() => {
          const pp_length = part_program_list.length;
          for (let i = 0; i < pp_length; i++) {
            const part_program = part_program_list[i];
            const step_length = part_program.steps.length;
            for (let j = 0; j < step_length; j++) {
              const step = part_program.steps[j];
              const interf = that.getInterfaceById(step.interface_id);
              if (interf != null) {
                const module = that.getModuleById(interf.module_id);
                const fields = module.part_program_fields;
                for (let z = 0; z < fields.length; z++) {
                  const field = fields[z];
                  if (step.register[field.field] == undefined) {
                    step.register[field.field] = {
                      value: field.default_value,
                      parameters: new Array(),
                    };
                  }
                }
              }
            }
          }
          that.part_program_list = part_program_list;
        });
    },
    //#endregion

    //#region SET
    setMachinePrograms() {
      const encoded = btoa(
        unescape(encodeURIComponent(JSON.stringify(this.part_program_list)))
      );
      const that = this;
      this.NETWORK.AjaxRequest({
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "setmachineprograms",
          token: localStorage.user_token,
          machine_id: this.id_macchina,
          part_prog_4_0: encoded,
        },
        method: "PUT",
        on: {
          load: function () {
            that.ui.snackbar = true;
          },
        },
      });
    },
    //#endregion
  },
};
</script>